var _rect, _g, _rect2, _g2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomepageStreetBlocks = function SvgHomepageStreetBlocks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1247,
    height: 1576,
    viewBox: "0 0 1247 1576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360.716,
    height: 801.739,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 255.065 0)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 151.821,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 354.6 556.629)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 131.023,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 489.159 691.188)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 136.223,
    height: 106.067,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 435.482 637.513)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 110.226,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 299.452 500.461)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 102.947,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 588.425 543.395)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 102.947,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 534.748 489.717)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 114.386,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 414.895 386.04)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 102.947,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 367.834 322.806)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 116.465,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 244.305 446.335)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 131.023,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 191.363 393.394)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 131.023,
    height: 67.5915,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 137.944 339.973)",
    fill: "#DAE0E8"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 483.539,
    height: 801.739,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 337.331 1233.8)",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 134.143,
    height: 67.5915,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 1127.78 1068.36)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 134.143,
    height: 67.5915,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 1011.6 1172.77)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 134.143,
    height: 67.5915,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 857.187 955.119)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 134.143,
    height: 67.5915,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 707.92 1104.38)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 169.499,
    height: 67.5915,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 899.098 1045.56)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 169.499,
    height: 67.5915,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 795.421 1162.47)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 169.499,
    height: 67.5915,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1013.07 937.473)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 194.455,
    height: 67.5915,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 768.95 853.649)",
    fill: "#DAE0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 194.455,
    height: 67.5915,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 510.861 1111.74)",
    fill: "#DAE0E8"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 23.397,
    transform: "matrix(1 0 0 -1 1056.14 1044.87)",
    fill: "#C4C4C4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomepageStreetBlocks);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";